import React, { useState, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

import Modal from '../Modal/Modal'

import InfoImg from '../../assets/info.svg'

import './TermsModal.css'

export const SAVE_CARD = 'saveCard'
export const LOYALTY = 'loyalty'
export const CONTACTLESS = 'contactless'

const termsModalEnums = [
  SAVE_CARD,
  LOYALTY,
  CONTACTLESS
]

const getTextFromTermsEnum = (terms) => {
  switch (terms) {
    case SAVE_CARD:
      return {
        responsive: false,
        header: 'Remember This Card',
        body: (
          <div styleName='body'>
            By selecting “Remember this card” and clicking on “Save” you are authorizing
            Toast, Inc. to store your credit card information provided above (the “Card”),
            and to charge your Card for future purchases initiated by you.
            You may update your Card information or cancel this authorization any time via
            the “My Account” page of the Toast Online Ordering website. This authorization
            will remain in effect until updated or canceled.
          </div>
        )
      }
    case LOYALTY:
      return {
        responsive: false,
        header: 'Joining Loyalty Rewards',
        body: (
          <div styleName='body'>
            You are agreeing to participate in the rewards program and to be contacted
            through this email as part of the program.
            <br />
            Rewards program information is subject to Toast's{' '}
            <a href='https://pos.toasttab.com/terms-of-service#diner-tos' rel='noopener noreferrer' target='_blank' data-testid='link-terms-of-service'>
              Diner Terms of Service
            </a>{' '}
            and{' '}
            <a href='https://pos.toasttab.com/privacy' rel='noopener noreferrer' target='_blank' data-testid='link-privacy'>
              Privacy Statement.
            </a>
          </div>
        )
      }
    case CONTACTLESS:
      return {
        responsive: false,
        header: 'Request contactless delivery',
        body: (
          <div styleName='body'>
            <p>
              Get your order in a way that promotes safety for you and your delivery person with a no-contact option.
            </p>
            <h3 styleName='termsListHeader'>1. Add a note to your delivery instructions</h3>
            <p>
              Let your delivery person know where you would like your order to be placed for pickup. Try to be as specific as possible.
            </p>
            <h3 styleName='termsListHeader'>2. Be on the lookout for a call</h3>
            <p>
              Your delivery person may use the phone number you provided to get in touch when they arrive with your food.
            </p>
          </div>
        )
      }
    default:
      break
  }
}

export const TermsModal = ({ onClose, terms }) => {
  const { header, body, responsive } = getTextFromTermsEnum(terms)

  return (
    <Modal header={header} onClose={onClose} responsive={responsive}>
      {body}
    </Modal>
  )
}

export const useTermsModal = ({ terms, show = false }) => {
  const [showModal, setShowModal] = useState(show)

  const handleOpen = useCallback(() => {
    setShowModal(true)
  }, [])

  const handleClose = useCallback(() => {
    setShowModal(false)
  }, [])

  return useMemo(() => ({
    openModal: handleOpen,
    TermsModal:
      (props) => (
        showModal && <TermsModal terms={terms} onClose={handleClose} {...props} />
      )

  }), [handleClose, handleOpen, showModal, terms])
}

export const LearnMoreButton = ({ onClick, ...props }) => {
  return (
    <button
      type='button'
      styleName='infoButton'
      onClick={onClick}
      {...props}
    >
      <InfoImg styleName='infoImage' />
      Learn More
    </button>
  )
}

LearnMoreButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

TermsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  terms: PropTypes.oneOf(termsModalEnums)
}
